module.exports = __webpack_public_path__ + "static/media/ac-logo-full.a00d2cac.png";